var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import * as T from "sb-resp-ui";
import "blocks/AggregatesViewPresenterBlock/ui/AggregatesViewPresenterBlock.less";
import { AggregatesScoresBlockRoot } from "../../AggregatesScoresBlock";
import { AggregatesGamesBlockRoot } from "../../AggregatesGamesBlock";
import { AggregatesIncidentsBlockRoot } from "../../AggregatesIncidentsBlock";
// block components
import * as CMP from "../components";
let AggregatesViewPresenterBlock = class AggregatesViewPresenterBlock extends React.Component {
    constructor(props) {
        super(props);
        // setup dictionary
        this.dict = props.dict;
        // setup data provider
        this.state = {
            tabActive: "scores",
            dataProvider: props.dataProvider
        };
        this.tabsInstances = {
            scores: {},
            games: {},
            incidents: {}
        };
    }
    componentDidMount() {
        this.tabsInstances = {
            scores: new AggregatesScoresBlockRoot("rename-aggregate-scores", Object.assign({}, this.props.options)),
            games: new AggregatesGamesBlockRoot("rename-aggregate-games", Object.assign({}, this.props.options)),
            incidents: new AggregatesIncidentsBlockRoot("rename-aggregate-incidents", Object.assign({}, this.props.options))
        };
        this.tabsInstances.scores.activate();
    }
    deactivateAll() {
        Object.keys(this.tabsInstances).forEach(t => {
            typeof this.tabsInstances[t].deactivate === "function" && this.tabsInstances[t].deactivate();
        });
    }
    componentWillUnmount() {
        this.deactivateAll();
    }
    callTab(tab) {
        Object.keys(this.tabsInstances).forEach(x => this.tabsInstances[x][x === tab ? "activate" : "deactivate"]());
        this.setState({ tabActive: tab });
    }
    renderTabTrigger(text, isDefault, link) {
        return (React.createElement("div", { className: "rj-aggregate-tab-outer", onClick: () => this.callTab(link) },
            React.createElement(T.TabTrigger, { default: isDefault, link: link },
                React.createElement("a", { className: "rj-aggregate-tab-inner" }, text))));
    }
    render() {
        return (React.createElement("div", null,
            React.createElement(CMP.HeadingNavigation, { dict: this.dict, info: this.state.dataProvider.generalInfo, goBack: this.props.options.navHandler.goBack }),
            React.createElement(T.Tabs, null,
                React.createElement("div", { className: "rj-aggregate-tabs-container" },
                    React.createElement(T.TabsTriggers, null,
                        this.renderTabTrigger(this.dict.scores, true, "scores"),
                        this.renderTabTrigger(this.dict.games, false, "games"),
                        this.renderTabTrigger(this.dict.incidents, false, "incidents"))),
                React.createElement(T.TabsBlocks, null,
                    React.createElement(T.TabBlock, { link: "scores" },
                        React.createElement("div", { id: "rename-aggregate-scores" })),
                    React.createElement(T.TabBlock, { link: "games" },
                        React.createElement("div", { id: "rename-aggregate-games" })),
                    React.createElement(T.TabBlock, { link: "incidents" },
                        React.createElement("div", { id: "rename-aggregate-incidents" }))))));
    }
};
AggregatesViewPresenterBlock = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], AggregatesViewPresenterBlock);
export { AggregatesViewPresenterBlock };
//# sourceMappingURL=AggregatesViewPresenterBlock.js.map